// 新規申し込みの受付終了の案内（Issue #262）。
//
// 有料化をやめて予想を誰でも見られるようにしたため、プラン選択と申込（Issue #36）は閉じた。
// サーバ側も `BILLING_SIGNUP_CLOSED` で checkout / purchase を 403 にしている。
// LP やブックマークからのリンク切れを避けるため、`/plan` のルート自体は残してここに案内を出す。
// 既存のご契約の確認・解約はマイページ（`/mypage`）で引き続き行える。
import React, { useContext } from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import PredictionServiceNav from '../components/predictionService/PredictionServiceNav';

const PAPER_SX = {
  p: { xs: 2.5, sm: 3.5 },
  borderRadius: 4,
  color: 'inherit',
  border: '1px solid rgba(92, 160, 219, 0.2)',
  background: 'linear-gradient(180deg, rgba(10,24,41,0.92), rgba(4,10,20,0.95))',
};

const PREDICTION_LINKS = [
  { to: '/chiriri_model_race_list', label: '中央競馬の予想を見る' },
  { to: '/nar_model_race_list', label: '地方競馬の予想を見る' },
  { to: '/keirin_model_race_list', label: '競輪の予想を見る' },
];

function PlanSelectPage() {
  const { isAuthenticated } = useContext(AuthContext);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background:
          'radial-gradient(circle at 15% 0%, rgba(43,132,255,0.22), transparent 28%), radial-gradient(circle at 90% 10%, rgba(50,255,226,0.14), transparent 24%), linear-gradient(180deg, #02060d 0%, #07111d 46%, #03070f 100%)',
        color: '#eef8ff',
        fontFamily: '"Avenir Next", "Yu Gothic", "Hiragino Sans", sans-serif',
      }}
    >
      <Box sx={{ maxWidth: 960, mx: 'auto', px: { xs: 2, sm: 3 }, py: { xs: 3, sm: 4 } }}>
        <Stack spacing={3}>
          <PredictionServiceNav />

          <Paper sx={PAPER_SX}>
            <Typography
              sx={{ color: '#71dbff', fontSize: 12, letterSpacing: '0.24em', textTransform: 'uppercase' }}
            >
              Plan
            </Typography>
            <Typography sx={{ mt: 1, fontSize: { xs: 24, sm: 30 }, fontWeight: 700 }}>
              新規のお申し込みは終了しました
            </Typography>
            <Typography sx={{ mt: 1.5, color: 'rgba(203, 229, 245, 0.72)' }}>
              中央競馬・地方競馬・競輪の予想は、どなたでも無料でご覧いただけます。
            </Typography>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ mt: 3 }}>
              {PREDICTION_LINKS.map((link) => (
                <Button
                  key={link.to}
                  component={RouterLink}
                  to={link.to}
                  variant="contained"
                  sx={{ borderRadius: 999, px: 3, textTransform: 'none', fontWeight: 700 }}
                >
                  {link.label}
                </Button>
              ))}
            </Stack>

            {isAuthenticated && (
              <Typography sx={{ mt: 3, fontSize: 14, color: 'rgba(203, 229, 245, 0.72)' }}>
                ご契約中の方は、
                <Box component={RouterLink} to="/mypage" sx={{ color: '#9ed7ff' }}>
                  マイページ
                </Box>
                でご契約内容の確認・解約ができます。
              </Typography>
            )}
          </Paper>
        </Stack>
      </Box>
    </Box>
  );
}

export default PlanSelectPage;
